import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a903547c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents" }
const _hoisted_2 = { class: "main-form" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"0.1rem"} }, "+", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新 增")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("批量删除")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("批量导入")
const _hoisted_9 = { class: "main-table" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = { class: "upd" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"10px"} }, "请选择填充好的模板文件", -1))
const _hoisted_15 = { class: "dialog-footer1" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("下载模版文件")
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("确认")

import { reactive, ref, onMounted } from "vue";
import { getlistQuestions, deleteQuestions } from "@/api/backstage";
import { useRouter } from "vue-router";
import { InfoFilled } from "@element-plus/icons-vue";
import { ElForm, ElMessage } from "element-plus";
import axios from "axios";
import Uploadfile from "./Uploadfile.vue";
type FormInstance = InstanceType<typeof ElForm>;


export default /*#__PURE__*/_defineComponent({
  __name: 'examQuestion',
  setup(__props) {

const dialogVisible = ref(false); //弹框显示隐藏
const formRef = ref<FormInstance>();
const ruleFormRef = ref<FormInstance>();
const router = useRouter();
const datas: any = reactive({
  fileIds: "",
  filurl: localStorage.getItem("fileUrl"),
  konwles: "",
  tableData: [],
  total: 0,
  subject: [],
  ids: [],
  type: {
    QUESTION_ONE: {
      enumName: "单选",
      enumKey: "QUESTION_ONE",
    },
    QUESTION_MORE: {
      enumName: "多选",
      enumKey: "QUESTION_MORE",
    },
    QUESTION_SHORT: {
      enumName: "简答",
      enumKey: "QUESTION_SHORT",
    },
    QUESTION_NUM: {
      enumName: "打分",
      enumKey: "QUESTION_NUM",
    },
  },
  form: {
    pageNum: 1,
    pageSize: 10,
    title: "",
    type: "",
  },
});

//上传文件成功
const fileSuccess = (val: any) => {
  datas.fileIds = [];
  for (const item of val.value) {
    datas.fileIds.push(item.id);
  }
};

const handleSelectionChange = (val: any) => {
  // console.log(val);
  datas.ids = val;
};



const getList = async () => {
  const res = await getlistQuestions(datas.form);
  datas.tableData = res.data.list;
  datas.total = res.data.total;
};

// 批量删除
const batchDel = async () => {
  let ids: any = [];
  datas.ids.forEach((item: any) => {
    ids.push(item.id);
  });
  const res = await deleteQuestions({ids});
  if (res.code === 200) {
    ElMessage({
      message: "删除成功",
      type: "success",
    });
    getList();
  } else {
    ElMessage({
      message: "删除失败",
      type: "error",
    });
  }
};

// 类型筛选
const typeChange = (val: any) => {
  datas.form.type = val;
  getList();
};

// 筛选重置
const resetForm = (val: any) => {
  datas.form.type = "";
  datas.form.title = "";
  getList();
};

const downloadTemplate = () => {
  console.log(window.sessionStorage, "5555");
  let headers = { "user-token": window.sessionStorage.getItem("token") };
  axios({
    method: "get", //请求方式
    headers: headers,
    url: process.env.VUE_APP_BASE_API + "/core/question/downloadTemplate", //请求地址
    responseType: "blob", //文件流将会被转成blob
  }).then((res: any) => {
    const blob = new Blob([res]); //处理文档流
    console.log(res, "5555");

    const fileName = "问卷试题导入模板.xlsx";
    const down = document.createElement("a");
    down.download = fileName;
    down.style.display = "none"; //隐藏,没必要展示出来
    down.href = URL.createObjectURL(blob);
    document.body.appendChild(down);
    down.click();
    URL.revokeObjectURL(down.href); // 释放URL 对象
    document.body.removeChild(down); //下载完成移除
  });
};

const filsh = () => {
  dialogVisible.value = false;
  getList();
};

const handleSizeChange = (val: number) => {
  datas.form.pageSize = val;
  getList();
};
const handleCurrentChange = (val: number) => {
  datas.form.pageNum = val;
  getList();
};

//删除试题
const confirmEvent = async (row: any) => {
  const res = await deleteQuestions({ id: String(row.id) });
  if (res.code === 200) {
    ElMessage({
      message: "删除成功",
      type: "success",
    });
    getList();
  } else {
    ElMessage({
      message: "删除失败",
      type: "error",
    });
  }
};

onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElForm), {
        inline: true,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: datas.form,
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "标题",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: datas.form.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datas.form.title) = $event)),
                onKeyup: _withKeys(getList, ["enter","native"]),
                placeholder: "关键字"
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "类型",
            prop: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: datas.form.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datas.form.type) = $event)),
                placeholder: "请选择",
                onChange: typeChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.type, (v, k) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: v.enumName,
                      value: k,
                      key: k
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "addButton",
            onClick: getList
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (resetForm(ruleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "addButton",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/backstage/examQuestionDetails?edit=false')))
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            disabled: datas.ids.length == 0,
            onClick: batchDel
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogVisible.value = true))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_table, {
        data: datas.tableData,
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            type: "index",
            width: "80",
            label: "序号"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "title",
            label: "题干"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", {
                innerHTML: row.title
              }, null, 8, _hoisted_10)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "type",
            label: "类型"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(datas.type[row.type]?.enumName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            sortable: "",
            align: "center",
            prop: "createTime",
            label: "创建时间"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "sortNum",
            label: "操作"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                type: "text",
                class: "ubbutton",
                onClick: ($event: any) => (
                _unref(router).push(
                  `/backstage/examQuestionDetails?id=${row.id}&edit=true`
                )
              )
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                "confirm-button-text": "是",
                "cancel-button-text": "否",
                icon: _unref(InfoFilled),
                "icon-color": "red",
                title: "确认删除该条数据？",
                onConfirm: ($event: any) => (confirmEvent(row))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    class: "debutton"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["icon", "onConfirm"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_pagination, {
      currentPage: datas.form.pageNum,
      "page-size": datas.form.pageSize,
      "page-sizes": [10, 20, 50, 100],
      background: "",
      layout: "total, sizes, prev, pager, next, jumper",
      total: Number(datas.total),
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["currentPage", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisible).value = $event)),
      title: "批量导入试题",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: downloadTemplate
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: filsh
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          (dialogVisible.value)
            ? (_openBlock(), _createBlock(Uploadfile, {
                key: 0,
                onOnSuccess: fileSuccess
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})